import { IPublishTimetableRequestBody, IPublishTimetableResponseBody } from './types';
import { API_URL } from '../constants';
import { postPublishRequest } from '../postPublishRequest/postPublishRequest';

export const publishTimetable = (
  timetableId: string,
  payload: IPublishTimetableRequestBody,
): Promise<IPublishTimetableResponseBody> =>
  postPublishRequest(
    `${API_URL}/publish/timetables/${timetableId}`,
    payload,
    'Something went wrong whilst publishing the timetable',
  );
